<!--
 * @Author: youthscc(蒋松)
 * @Date: 2024-10-15 10:18:02
 * @LastEditors: youthscc(蒋松)
 * @LastEditTime: 2024-10-16 18:35:48
-->
<template>
  <Modal center width="400px" v-model="show" @on-cancel="handleCancel">
    <template #header>
      <h2>{{$t('MENUSLIDE.shen-fen-yan-zheng')}}</h2>
    </template>
    <div>{{ props.title }}{{ $t('MENUSLIDE.xu-yao-jin-xing-sheng-fen-yan-zheng') }}{{ showTitle }}</div>
    <CaptchaInput ref="codeRef" v-model="code" :userInfo="userInfo" />
    <template #footer>
      <div>
        <Button @click="handleCancel" ghost type="primary">{{$t('MENUSLIDE.qu-xiao')}}</Button>
        <Button :disabled="loading" @click="handleOk" type="primary">{{ $t('MENUSLIDE.que-ren') }}</Button>
      </div>
    </template>
  </Modal>
</template>
<style lang="less"></style>
<script setup>
import { ref, onMounted, defineProps, defineEmits, watch } from 'vue'
import CaptchaInput from './captchaInput'
import { Modal, Button, Message } from 'view-ui-plus'
import platform from '../../data/platform'

const props = defineProps({
  modelValue: Boolean,
  title: String,
  validateType: String // EMAIL & MOBILE
})
const codeRef = ref(null)
watch(() => props.modelValue, (val) => {
  show.value = val
  codeRef.value && codeRef.value.clearCode()
})

watch(() => props.validateType, async (val) => {
  const res = await platform.getSecurityUserInfo()
  const { data: { data } } = res
  userInfo.value = data
  const { mobile, email } = userInfo.value
  if (val === 'EMAIL') {
    showTitle.value = '邮箱' + email.replace(/^(.{3}).+(.{3})$/, '$1****$2')
  } else if (val === 'MOBILE') {
    showTitle.value = '手机' + mobile.replace(/(\d{3})\d{4}(\d+)/, '$1****$2')
  }
})

const emit = defineEmits(['update:modelValue', 'success'])
const code = ref('')
const userInfo = ref({})
const showTitle = ref('')
const loading = ref(false)
const show = ref(false)
onMounted(async () => {
  show.value = props.modelValue
})

const handleCancel = () => {
  emit('update:modelValue', false)
}

const handleOk = window._.debounce(async () => {
  if (!code.value) {
    Message.warning('请输入验证码')
    return
  }
  handleCancel()
  emit('success', code.value); return
}, 300)
</script>